// extracted by mini-css-extract-plugin
export default {"primary-btn":"ModalBtn_primary-btn__odXVJ","cancel-btn":"ModalBtn_cancel-btn__w4MD4"};